// Copyright (c) Docugami, Inc. All rights reserved.

import { ClusterInfo } from '../../networking/api'
import { FetchState } from '../shared_types'

export interface FetchStateUpdate {
    clusterId: string;
    fetchState: FetchState;
}

export interface ClusterState {
    documentsFetchState: FetchState;
    clusterInfo: ClusterInfo;
    docIds: string[];
}

export interface ClustersState {
    isFetching: boolean;
    fetched: boolean;
    indexed: { [id: string]: ClusterState };
    allIds: string[];
}

export interface AddOrRemoveFromCluster {
    folderIds: string[];
    clusterId: string;
}

export interface StringValueForClusterId {
    clusterId: string;
    value: string;
}

export interface BooleanValueForClusterId {
    clusterId: string;
    value: boolean;
}

export interface StrArrValueForClusterId {
    clusterId: string;
    value: string[];
}

export const UPDATE_ClUSTERS_STATE = "UPDATE_CLUSTERS_STATE";
export const SET_DOC_FETCH_STATE = "SET_DOC_FETCH_STATE";
export const UPDATE_CLUSTER_INFO = "UPDATE_CLUSTER_INFO";
export const REMOVE_FROM_CLUSTER = "REMOVE_FROM_CLUSTER";
export const ADD_TO_CLUSTER = "ADD_TO_CLUSTER";
export const ADD_NEW_CLUSTER = "ADD_NEW_CLUSTER";
export const REMOVE_CLUSTERS = "REMOVE_CLUSTERS";
export const ADJUST_CLUSTER_DOC_COUNT = "ADJUST_CLUSTER_DOC_COUNT";

export interface AdjustClusterDocCount {
    clusterId: string;
    delta: number;
}

interface UpdateClustersState {
    type: typeof UPDATE_ClUSTERS_STATE;
    payload: ClustersState;
}
interface SetDocumentsFetchState {
    type: typeof SET_DOC_FETCH_STATE;
    payload: FetchStateUpdate;
}

interface UpdateClusterInfo {
    type: typeof UPDATE_CLUSTER_INFO;
    payload: ClusterInfo;
}

interface AddToCluster {
    type: typeof ADD_TO_CLUSTER;
    payload: AddOrRemoveFromCluster;
}

interface AddNewCluster {
    type: typeof ADD_NEW_CLUSTER;
    payload: ClusterInfo;
}

interface RemoveClusters {
    type: typeof REMOVE_CLUSTERS;
    payload: string[];
}

interface RemoveFromCluster {
    type: typeof REMOVE_FROM_CLUSTER;
    payload: AddOrRemoveFromCluster;
}

interface AdjustClusterDocCountAction {
    type: typeof ADJUST_CLUSTER_DOC_COUNT;
    payload: AdjustClusterDocCount;
}

export type ClustersActionTypes =
    UpdateClustersState |
    SetDocumentsFetchState |
    UpdateClusterInfo |
    AddToCluster |
    AddNewCluster |
    RemoveClusters |
    RemoveFromCluster |
    AdjustClusterDocCountAction
